export const diseaseInfo = {
    'Tomato_mosaic_virus': {
      name: 'Virus Mosaik Tomat (ToMV)',
      description: 'Penyakit yang disebabkan oleh Tomato Mosaic Virus, ditularkan melalui benih, tangan manusia, alat pertanian, dan tanaman inang lain. Virus dapat bertahan lama di tanah dan sisa tanaman.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Gunakan benih bebas virus (bersertifikat)\n' +
        '2. Disinfeksi alat dan tangan sebelum menyentuh tanaman\n' +
        '3. Singkirkan dan bakar tanaman yang terinfeksi\n' +
        '4. Hindari merokok saat menangani tanaman\n' +
        '5. Rotasi tanaman dengan non-inang'
    },
    'Target_Spot': {
      name: 'Bercak Target (Target Spot)',
      description: 'Penyakit yang disebabkan oleh jamur Corynespora cassiicola, menyebar melalui udara, percikan air hujan, dan alat yang terkontaminasi. Menyebabkan bercak coklat dengan lingkaran konsentris pada daun.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Gunakan varietas tahan penyakit jika tersedia\n' +
        '2. Pangkas dan buang daun yang terinfeksi\n' +
        '3. Tingkatkan sirkulasi udara\n' +
        '4. Semprot fungisida yang sesuai\n' +
        '5. Lakukan rotasi tanaman'
    },
    'Bacterial_spot': {
      name: 'Bercak Bakteri (Bacterial Spot)',
      description: 'Penyakit yang disebabkan oleh bakteri Xanthomonas campestris pv. vesicatoria, menyebar melalui benih, air, dan kontak alat/pekerja. Menyebabkan bercak kecil berwarna coklat kehitaman pada daun dan buah.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Gunakan benih bebas patogen\n' +
        '2. Semprot bakterisida berbahan dasar tembaga\n' +
        '3. Hindari penyiraman dari atas\n' +
        '4. Rotasi tanaman minimal 2 tahun\n' +
        '5. Bakar sisa tanaman setelah panen'
    },
    'Early_blight': {
      name: 'Hawar Daun Dini (Early Blight)',
      description: 'Penyakit yang disebabkan oleh jamur Alternaria solani. Umum terjadi pada kondisi lembap dan suhu hangat. Menyebar melalui cipratan air hujan/irigrasi dari tanah dan residu tanaman yang terinfeksi. Menyebabkan bercak coklat tua dengan lingkaran konsentris seperti target di daun tua.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Sanitasi: Buang daun yang terinfeksi dan sisa tanaman setelah panen\n' +
        '2. Rotasi tanaman: Hindari menanam tomat atau kentang di tempat yang sama selama 2–3 tahun\n' +
        '3. Mulsa tanah: Cegah cipratan air tanah ke daun\n' +
        '4. Fungisida: Gunakan fungisida berbahan aktif seperti chlorothalonil, mancozeb, atau copper-based fungicides\n' +
        '5. Varietas tahan: Gunakan varietas tomat yang tahan terhadap Early Blight jika tersedia'
    },
    'Spider_mites Two-spotted_spider_mite': {
      name: 'Tungau Laba-laba (Two-Spotted Spider Mite)',
      description: 'Hama tungau kecil yang hidup di bawah daun dan mengisap cairan sel tanaman. Menyukai kondisi panas dan kering. Menyebabkan bercak kuning kecil (stippling) di daun dan jaring halus (webbing) di bawah daun.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Air semprot: Semprotkan air tekanan tinggi ke daun bagian bawah\n' +
        '2. Predator alami: Gunakan musuh alami seperti Phytoseiulus persimilis\n' +
        '3. Insektisida selektif: Gunakan mitisida seperti abamectin, spinosad, atau neem oil\n' +
        '4. Pengelolaan lingkungan: Jaga kelembapan agar tidak terlalu kering'
    },
    'Septoria_leaf_spot': {
      name: 'Bercak Daun Septoria (Septoria Leaf Spot)',
      description: 'Penyakit yang disebabkan oleh jamur Septoria lycopersici. Menyukai lingkungan lembap dan hangat, sering muncul saat tanaman mulai berbunga. Menyebabkan bercak kecil bulat, coklat keabu-abuan dengan tepi gelap di daun bagian bawah.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Sanitasi: Buang daun yang terinfeksi dan sisa tanaman secara menyeluruh\n' +
        '2. Penyiraman tepat: Hindari membasahi daun saat menyiram\n' +
        '3. Rotasi tanaman: Hindari menanam tomat di lokasi yang sama setiap tahun\n' +
        '4. Fungisida: Gunakan fungisida seperti chlorothalonil, copper fungicides, atau mancozeb\n' +
        '5. Ventilasi baik: Beri jarak antar tanaman untuk meningkatkan sirkulasi udara'
    },
    'Tomato_Yellow_Leaf_Curl_Virus': {
      name: 'Virus Keriting Daun Kuning Tomat (TYLCV)',
      description: 'Penyakit yang disebabkan oleh Tomato Yellow Leaf Curl Virus yang ditularkan oleh kutu kebul (Bemisia tabaci). Dapat menyebar melalui tanaman inang lain atau alat pertanian yang terkontaminasi. Menyebabkan daun menguning, melengkung ke atas (curl), dan mengecil. Pertumbuhan tanaman terhambat, bunga dan buah jarang terbentuk.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Gunakan benih atau bibit yang resisten terhadap TYLCV\n' +
        '2. Kendalikan populasi kutu kebul dengan insektisida (imidakloprid atau abamektin) atau perangkap kuning\n' +
        '3. Cabut dan bakar tanaman yang terinfeksi untuk mencegah penyebaran\n' +
        '4. Hindari menanam tomat dekat tanaman inang seperti cabai atau terung\n' +
        '5. Pasang mulsa plastik perak untuk mengusir kutu kebul'
    },
    'Late_blight': {
      name: 'Hawar Daun Akhir (Late Blight)',
      description: 'Penyakit yang disebabkan oleh jamur Phytophthora infestans, menyebar melalui spora yang terbawa angin, air hujan, atau kelembaban tinggi. Menyebabkan bercak coklat kehitaman pada daun, batang, atau buah, sering dengan tepi berwarna putih (seperti kapang). Daun layu dan tanaman cepat mati dalam kondisi lembab.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Gunakan fungisida sistemik (metalaksil atau dimetomorf) atau fungisida kontak (tembaga)\n' +
        '2. Hindari penyiraman dari atas dan jaga jarak tanam untuk sirkulasi udara\n' +
        '3. Buang bagian tanaman yang terinfeksi dan bakar sisa tanaman setelah panen\n' +
        '4. Rotasi tanaman dengan non-solanaceae (misalnya kacang-kacangan) selama 2-3 tahun'
    },
    'Leaf_Mold': {
      name: 'Jamur Daun (Leaf Mold)',
      description: 'Penyakit yang disebabkan oleh jamur Passalora fulva, berkembang pesat di lingkungan lembab dan sirkulasi udara buruk. Menyebabkan bercak kuning di permukaan daun atas dan lapisan berbulu coklat/abu-abu di bawah daun. Daun mengering dan gugur prematur, mengurangi hasil panen.',
      treatment: 'Penanganan yang disarankan:\n' +
        '1. Semprot fungisida seperti klorotalonil atau mankozeb\n' +
        '2. Kurangi kelembapan dengan ventilasi baik (misalnya greenhouse) atau jarak tanam lebar\n' +
        '3. Hindari penyiraman di malam hari\n' +
        '4. Rotasi tanaman dan bersihkan sisa tanaman setelah panen'
    },
    'healthy': {
      name: 'Daun Tomat Sehat',
      description: 'Daun tomat yang sehat dan bebas dari infeksi penyakit, menunjukkan pertumbuhan yang baik dengan warna hijau cerah. Tidak ada bercak, bintik, atau kerusakan pada daun, dan tanaman menunjukkan perkembangan optimal serta hasil panen yang maksimal.',
      treatment: 'Langkah-langkah menjaga daun tomat tetap sehat:\n' +
        '1. Pastikan pemberian nutrisi seimbang dan tepat\n' +
        '2. Rajin menyiram secara cukup dan merata, hindari kelebihan air\n' +
        '3. Gunakan pestisida nabati atau alami jika muncul tanda awal serangan hama atau penyakit\n' +
        '4. Jaga sirkulasi udara yang baik di sekitar tanaman\n' +
        '5. Bersihkan dan buang daun yang mati atau terserang penyakit untuk mencegah penyebaran'
    }
  };